import { Router } from '@angular/router';
import { menuHome, menuLoginPhone, chilPath } from './../../../config/config';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'invalid-invoice-popup',
  templateUrl: './invalid-invoice-popup.component.html',
  styleUrls: ['./invalid-invoice-popup.component.scss'],
})
export class InvalidInvoicePopupComponent implements OnInit {

  
  constructor(private router: Router) { }

  ngOnInit() {}

  goHome() {
    this.router.navigate([menuHome.path]);
  }

  gotoCustomerInforSuccess() {
    this.router.navigate([`${menuLoginPhone.path}/${chilPath.customerInforSuccess}`]);
  }
}
